import { useState, useEffect } from "react";

function InstallPWA() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstall, setShowInstall] = useState(false);
  const [isInstalled, setIsInstalled] = useState(false);
  const [deviceType, setDeviceType] = useState("");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const detectDevice = () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const isIOS = /iphone|ipad|ipod/.test(userAgent);
      const isAndroid = /android/.test(userAgent);
      const isStandalone =
        window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone === true;

      if (isStandalone) {
        setIsInstalled(true);
        return;
      }

      if (isIOS) {
        setDeviceType("ios");
        setShowInstall(false); // hide for iOS
      } else if (isAndroid) {
        setDeviceType("android");
        setShowInstall(false); // hide for Android
      } else {
        setDeviceType("desktop");
        setShowInstall(false); // hide for desktop
      }
    };

    detectDevice();

    const handler = (e) => {
      console.log("beforeinstallprompt fired");
      e.preventDefault();
      setDeferredPrompt(e);
      // even if available, we hide it on Android
      setShowInstall(false);
      setDeviceType("android");
    };

    const installedHandler = () => {
      console.log("PWA was installed");
      setShowInstall(false);
      setIsInstalled(true);
      setDeferredPrompt(null);
      setShowModal(false);
    };

    window.addEventListener("beforeinstallprompt", handler);
    window.addEventListener("appinstalled", installedHandler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
      window.removeEventListener("appinstalled", installedHandler);
    };
  }, []);

  // ✅ Hide button for all devices (mobile + desktop)
  if (isInstalled) return null;
  if (!showInstall) return null;
  if (
    deviceType === "desktop" ||
    deviceType === "ios" ||
    deviceType === "android"
  )
    return null;

  return null; // nothing rendered
}

export default InstallPWA;
